module.exports = __webpack_public_path__ + "static/img/00 mains.6ef2ff2e.jpg";